import * as fromTiktokGraph from '../reducers/tiktok-graph.reducer'
import { createFeatureSelector, createSelector } from '@ngrx/store'
import { getCriteriaFrom, getCriteriaTo } from './criteria.selector'
import * as moment from 'moment'

export const getTiktokGraph = createFeatureSelector<fromTiktokGraph.State>('tiktokGraph')

export const getTiktok = createSelector(
  getTiktokGraph,
  state => state.tiktok
)

export const getLoading = createSelector(
  getTiktokGraph,
  state => state.loading
)

export const getLoaded = createSelector(
  getTiktokGraph,
  state => state.loaded
)

export const getTiktokCsv = createSelector(
  getTiktokGraph,
  getCriteriaFrom,
  getCriteriaTo,
  (state, from, to) => {
    const data = []
    data.push([
      '集計期間',
      moment(from).format('YYYY-MM-DD') + ' ~ ' + moment(to).format('YYYY-MM-DD'),
    ])
    data.push([])
    data.push(['日付'].concat([...new Set(state.tiktok.map(item => item.contentType))]))
    const dates = [...new Set(state.tiktok.map(item => item.streamDate))]
    const column = []
    dates.forEach(d => {
      const c: any[] = [d]
      column.push(c)
      state.tiktok.map(tiktok => {
        if (d === tiktok.streamDate) {
          c.push(tiktok.streams)
        }
      })
    })
    column.map(item => data.push(item))
    return data
  }
)
